import React, { useState } from "react";
import EditProfile from "./EditProfile";
import EditTradeReference from "./EditTradeReference";

const EditProfileTab = () => {
  const [activeTab, setActiveTab] = useState("edit-profile");
  return (
    <div className="container mb-5">
      <div className="tab-container mb-3">
        <div className="tab-item">
          <div
            onClick={() => setActiveTab("edit-profile")}
            className={`tab-item-link ${
              activeTab === "edit-profile" ? "active" : ""
            }`}
          >
            Edit Profile
          </div>
          <div
            onClick={() => setActiveTab("edit-trade-reference")}
            className={`tab-item-link ${
              activeTab === "edit-trade-reference" ? "active" : ""
            }`}
          >
            Edit Trade Reference
          </div>
        </div>
      </div>
      {activeTab === "edit-profile" && <EditProfile />}
      {activeTab === "edit-trade-reference" && <EditTradeReference />}
    </div>
  );
};

export default EditProfileTab;
